$(document).on("click", "#dashboard-machine-set-idle", function(){
  const record_id = $("#mid").attr("mid")

  $.ajax({
    url: "/dashboard/idles/" + record_id,
    dataType: 'script',
    success: function(res){
      $('.modal-body').html(res)
    }
  })
})

$(document).on("click", "#dashboard-machine-cancel-set-idle", function(){
  const record_id = $("#machine-idle-selection").attr("mid")
  __dashboard_show(record_id)
})

$(document).on("click", ".machine-set-idle", function () {
  $(".machine-set-idle").each(function (idx, elm) {
    $(elm).removeAttr('selected')
  })

  $(this).attr("selected", true)

  const machine_name = $(".modal-title").text()
  const idle_name = $(this).text()

  $("#machine-idle-selection-confirmation").find(".machine").val(machine_name)
  $("#machine-idle-selection-confirmation").find(".idle").val(idle_name)

  $("#machine-idle-selection").attr("hidden", "hidden")
  $("#machine-idle-selection-confirmation").removeAttr("hidden")
})

$(document).on("click", "#machine-idle-cancel-confirmation", function () {
  $("#machine-idle-selection").removeAttr("hidden")
  $("#machine-idle-selection-confirmation").attr("hidden", "hidden")
  $("#machine-idle-selection-confirmation .remarks").val("")
})

$(document).on("click", "#machine-idle-confirm-confirmation", function (){
  const machine_id = $("#machine-idle-selection").attr("mid")
  const idle = $(".machine-set-idle[selected='selected']").attr("record_id")
  const remarks = $("#machine-idle-selection-confirmation .remarks").val()

  $.ajax({
    url: "/dashboard/idles/" + machine_id,
    method: "PATCH",
    data: {
      idle_id: idle,
      remarks: remarks
    },
    headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
    success: function (res) {
      __dashboard_show(machine_id)
      __dashboard_refresh()
    },
    error: function (jqXHR) {
      alert(jqXHR.responseJSON.message)
    }
  })
})

$(document).on("click", "#machine-idle-unset", function () {
  const machine_id = $("#mid").attr("mid")
  const machine_name = $(".modal-title").text()

  if (!confirm(`Apakah anda yakin STOP idle mesin ${machine_name}?`)) {
    return false;
  }

  $.ajax({
    url: "/dashboard/idles/" + machine_id,
    method: "DELETE",
    headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
    success: function (res) {
      __dashboard_show(machine_id)
      __dashboard_refresh()
    },
    error: function (jqXHR) {
      alert(jqXHR.responseJSON.message)
    }
  })
})